import clsx from "clsx";
import { useTranslation } from "react-i18next";

interface SpinnerProps {
  size?: number;
  color?: "primary" | "inherit";
  className?: string;
}

export function Spinner({ size = 40, color = "primary", className }: SpinnerProps) {
  const { t } = useTranslation(["components", "common"]);

  return (
    <svg
      role="progressbar"
      aria-label={t("common:state.loading")}
      className={clsx("animate-spin", color === "primary" && "text-primary", className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4Zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647Z"
      />
    </svg>
  );
}
